// extracted by mini-css-extract-plugin
module.exports = {"companySuggestions":"styles_companySuggestions__1TCow","companySuggestion":"styles_companySuggestion__1yXG4","spin":"styles_spin__1xVaO"};